// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.populerProduct__container {
    cursor: pointer;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 0.75rem;
    --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.populerProduct__wrapper {
    display: flex;
    align-items: center;
    justify-content: center
}
.populerProduct__wrapper img {
    aspect-ratio: auto;
    width: 100%;
    object-fit: cover;
    object-position: center
}
.threeCollumImages__wrapper h1 {
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1))
}`, "",{"version":3,"sources":["webpack://./src/components/Widgets/PopulerProduct/populerProduct.css"],"names":[],"mappings":"AACI;IAAA,eAA4D;IAA5D,uBAA4D;IAA5D,kBAA4D;IAA5D,4DAA4D;IAA5D,gBAA4D;IAA5D,mGAA4D;IAA5D;AAA4D;AAG5D;IAAA,aAAuC;IAAvC,mBAAuC;IAAvC;AAAuC;AAGvC;IAAA,kBAAoD;IAApD,WAAoD;IAApD,iBAAoD;IAApD;AAAoD;AAGpD;IAAA,kBAAgE;IAAhE,iBAAgE;IAAhE,gBAAgE;IAAhE,yBAAgE;IAAhE,uBAAgE;IAAhE,oBAAgE;IAAhE;AAAgE","sourcesContent":[".populerProduct__container {\n    @apply bg-white drop-shadow-md rounded-md cursor-pointer p-3; \n}\n.populerProduct__wrapper {\n    @apply flex items-center justify-center;\n}\n.populerProduct__wrapper img {\n    @apply w-full aspect-auto object-cover object-center;\n}\n.threeCollumImages__wrapper h1 {\n    @apply text-xs font-light tracking-wide uppercase text-slate-500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
